<template>
    <div style="display: flex; flex-direction: column; align-items: center">
        <div style="margin-top: 28px">
            <span style="font-size: 22px">相关资料</span>
        </div>
        <div class="jxzb-table" style="width: 100%">
            <div style="text-align: right; padding: 10px">
                <span>
                    <el-button v-if="type !== 'attachment' && canEdit == 1" icon="el-icon-connection" @click="openZyfj">转移附件</el-button>
                    <el-button v-if="type !== 'attachment' && canEdit == 1" icon="el-icon-upload2" @click="opendialog">上传文件</el-button>
                    <el-button icon="el-icon-download" @click="todownload">批量下载</el-button>
                </span>
            </div>
            <!-- <el-table :data="tableData" :span-method="objectSpanMethod" border class="jxzb-tables"> -->
            <el-table ref="table" :default-sort="{ prop: 'flCreateDate', order: 'descending' }" :data="tableData" border class="jxzb-tables" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column type="index" label="序号" width="50" align="center" />
                <el-table-column prop="flType" label="文件类型" width="150" align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>{{ scope.row.flType | filterType }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="fileNameType" label="文件名称" align="left" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span v-if="type !== 'attachment' && canEdit == 1" style="color: #42a5f5" @click="openwork(scope.row)">{{ scope.row.fileNameType }}</span>
                        <span v-else>{{ scope.row.fileNameType }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="fileSize" label="文件大小" width="150" align="center" :show-overflow-tooltip="true" />
                <el-table-column prop="flCreator" label="上传人" width="120" align="center" :show-overflow-tooltip="true" />
                <el-table-column prop="flCreateDate" label="上传时间" width="150" align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>{{ $moment(scope.row.flCreateDate).format('YYYY年MM月DD日') }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center">
                    <template slot-scope="scope">
                        <el-link type="primary" @click="todownload(scope.row)">下载</el-link>
                    </template>
                </el-table-column>
            </el-table>
            <div v-if="changeLogList.length > 0" class="change-content">
                <div style="font-weight: bold">变更说明：</div>
                <div class="text">
                    <div v-for="(item, index) in changeLogList" :key="item.id">{{ index + 1 }}.{{ item.operateDesc }}</div>
                </div>
            </div>
            <el-dialog title="上传附件" :visible.sync="showlzDialog" width="824px">
                <el-form>
                    <div class="el-table el-table--fit el-table--border" style="width: 824px; margin-top: 10px">
                        <div class="el-table__body-wrapper">
                            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                                <tbody>
                                    <tr>
                                        <td class="el-table__cell tdlbl tdw17">
                                            <span class="required">*</span>
                                            文件类型
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <el-select v-model="fileType" placeholder="请选择">
                                                <el-option v-for="item in selOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                            </el-select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="el-table__cell tdlbl tdw17">
                                            <span class="required">*</span>
                                            上传文件
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <div class="row-col">
                                                <el-upload ref="upload" :on-change="handleUploadChange" action :multiple="false" :limit="1" :file-list="fileList" :show-file-list="true" :auto-upload="false" :on-remove="handleRemove">
                                                    <el-button slot="trigger" type="text">选择文件</el-button>
                                                </el-upload>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-form>

                <span slot="footer" class="dialog-footer">
                    <el-button :disabled="disBtn" @click="showlzDialog = false">取 消</el-button>
                    <el-button type="primary" :disabled="disBtn" @click="toupload">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog v-if="showlzDialog2" :visible.sync="showlzDialog2" title="转移附件" width="824px">
                <el-form :model="vo">
                    <div class="el-table el-table--fit el-table--border" style="width: 824px; margin-top: 10px">
                        <div class="el-table__body-wrapper">
                            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                                <tbody>
                                    <!-- <tr>
                    <td ref="tdlbl_项目名称" class="el-table__cell tdlbl tdw17" colspan="1">
                      <span class="required">*</span>
                      <span v-field-lbl="'flSubject'" class="field">项目名称</span>
                    </td>
                    <td class="el-table__cell tdcont tdw83" colspan="5">
                      <form-item ref="flSubject"
                        :field="{ 'defaultValue': null, 'elementCanEdit': '{${curTN.tnCanEdit}}', 'elementCssHeight': null, 'elementCssWidth': null, 'elementFormatter': null, 'elementReadonly': 1, 'elementType': 'input', 'emptyMessage': '请选择项目名称', 'errorMessage': null, 'formTdAlign': 'text-left', 'formTdColspan': 0, 'isRequired': 1, 'onClickEvent': null, 'passenger': {}, 'propComment': '项目名称', 'propName': 'flSubject', 'propType': 'String', 'textFormatter': 'textfield', 'valueMaxLength': 1000, 'valueMinLength': null, 'model': 'vo.flSubject', 'option': [], 'autocomplete': 'off', 'dialog': 1, 'showWordLimit': false, 'dialogType': 'listpage', 'dialogOrgLevel': '', 'dialogListviewurl': 'zbgl.zbxmArch.list', 'tbFieldName': 'flsubject' }"
                        :vo="vo" :can-edit="1" />
                    </td>
                  </tr> -->

                                    <tr>
                                        <td class="el-table__cell tdlbl tdw17">
                                            <span class="required">*</span>
                                            所属项目
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <!-- <el-select v-model="fileType" placeholder="请选择">
                        <el-option v-for="item in selOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select> -->
                                            <el-input v-model="zyfj.projectName" class="responsive-input" placeholder="请选择所属项目" readonly>
                                                <template #suffix>
                                                    <!-- <span :style="{ color: '#409EFF' }" @click="openxm">选择</span> -->
                                                    <el-button icon="el-icon-more" @click="openxm" />
                                                </template>
                                            </el-input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="el-table__cell tdlbl tdw17">转移说明</td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <el-input v-model="zyfj.content" :rows="2" type="textarea" placeholder="请输入转移说明" />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-form>

                <span slot="footer" class="dialog-footer">
                    <el-button :disabled="disBtn2" @click="zysmCancel">取 消</el-button>
                    <el-button type="primary" :disabled="disBtn2" @click="zysmSave">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog title="招标项目档案" :visible.sync="showlzDialog3" width="1200px">
                <el-input v-model="searchValue" placeholder="搜索..." class="input-with-select" clearable @keyup.enter="search">
                    <template #append>
                        <el-button icon="el-icon-search" @click="search" />
                    </template>
                </el-input>
                <el-form>
                    <div class="el-table el-table--fit el-table--border" style="width: 1200px; margin-top: 10px">
                        <div class="el-table__body-wrapper">
                            <el-table ref="table" v-loading="tableLoading" :data="tableData2" border class="tables">
                                <!-- <el-table-column type="selection" width="50" align="center"></el-table-column> -->
                                <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
                                <el-table-column prop="flSubject" label="招标项目名称" align="center" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="flContent" label="招标内容和范围" align="center" width="180" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="flCreateDept" label="申请部门" align="center" width="150" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="flCreateDate" label="申请日期" align="center" width="150" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="flCreator" label="申请人" align="center" width="100" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="zbXmbh" label="招标项目编号" align="center" width="120" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="projectCode" label="公司统一编号" align="center" width="200" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="操作" label="操作" align="center" width="70">
                                    <template slot-scope="scope">
                                        <span :style="{ color: '#409EFF' }" @click="selectxm(scope.row)">选择</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-form>
                <div class="page_info">
                    <el-pagination :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
                </div>
                <!-- <span slot="footer" class="dialog-footer">
          <el-button :disabled="disBtn2" @click="xmCancel">关 闭</el-button>
          <el-button type="primary" :disabled="disBtn2" @click="xmSave">确 定</el-button>
        </span> -->
            </el-dialog>
        </div>
    </div>
</template>

<script>
export default {
    filters: {
        filterType(val) {
            if (val == 'ATTACH' || val == 'FORM_ATTACH' || val == 'ZBATTACH') {
                return '其他'
            } else {
                return val
            }
        }
    },
    components: {},
    props: {
        vo: {
            type: Object,
            default: function () {
                return {
                    id: ''
                }
            }
        },
        canEdit: { type: Number, default: 1 },
        wfEngineUrl: { type: String, default: null },
        type: { type: String, default: 'detail' }
    },
    data() {
        return {
            tableData: [],
            multipleSelection: [],
            showlzDialog: false,
            showlzDialog2: false,
            showlzDialog3: false,
            selOptions: [
                { label: '管理责任书', value: '管理责任书' },
                { label: '代理合同', value: '代理合同' },
                { label: '招标(采购)文件', value: '招标(采购)文件' },
                { label: '质疑回复', value: '质疑回复' },
                { label: '中标通知书', value: '中标通知书' },
                { label: '汇编资料', value: '汇编资料' },
                { label: '投标文件（中标）', value: '投标文件（中标）' },
                { label: '投标文件（非中标）', value: '投标文件（非中标）' },
                { label: '评价评议表', value: '评价评议表' },
                { label: '其他', value: '其他' }
            ],
            fd: '',
            fileList: [],
            disBtn: false,
            disBtn2: false,
            fileType: '管理责任书',
            zyfj: { projectId: '', projectName: '', attachmentIdList: [], content: '' },
            tableData2: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            searchValue: '',
            tableLoading: false,
            changeLogList: []
        }
    },
    computed: {},
    watch: {},
    created() {
        if (this.$route.query.wfEngineUrl) {
            this.wfEngineUrl = this.$route.query.wfEngineUrl
        }
        console.log(this.vo, 123123)
    },
    beforeDestroy() {},
    mounted() {
        this.getList()
        this.getChangeContent()
    },
    methods: {
        search() {
            this.getZbxmArchList()
        },
        selectxm(row) {
            this.zyfj.projectName = row.flSubject
            this.zyfj.projectId = row.id
            this.xmCancel()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        handleUploadChange(file) {
            console.log(file, 123123)
            this.fileList = []
            this.fd = ''
            const fd = new FormData()
            fd.append('file', file.raw)
            this.fd = fd
            this.fileList = [file]
        },
        handleRemove(file, fileList) {
            this.fileList = []
        },
        opendialog() {
            this.fileList = []
            this.showlzDialog = true
        },
        async getZbxmArchList() {
            this.tableLoading = true
            var searchMap = {}
            searchMap['flSubject'] = this.searchValue
            searchMap['flContent'] = this.searchValue
            searchMap['flCreateDept'] = this.searchValue
            searchMap['flCreateDate'] = this.searchValue
            searchMap['flCreator'] = this.searchValue
            searchMap['zbXmbh'] = this.searchValue
            searchMap['projectCode'] = this.searchValue
            const data = {
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                searchAndOr: 'or',
                searchMap: searchMap,
                listpageViewUrl: 'zbgl.zbxmArch.list.vue'
                // urlsearch: `id!:${this.ids};typeFullId like ${this.selectTreeId};assetStatus:${this.assetStatus};status:1`
            }
            const res = await this.$app.listdata('zbgl/zbxmArch/listdata', data)
            if (res.code === 'success') {
                this.total = res.body.pageInfo.total
                this.tableData2 = res.body.pageInfo.list
            } else {
                this.tableData2 = []
                this.total = 0
            }
            this.tableLoading = false
        },
        getChangeContent() {
            console.log(this.vo.id, 'this.vo.id')
            this.$http({
                url: '/zbgl/zbxmArch/sysLogByProjectId',
                method: 'get',
                contentType: 'application/x-www-form-urlencoded',
                params: {
                    projectId: this.vo.id,
                    operateType: 'transferAttachment'
                }
            }).then((res) => {
                if (res.code === 'success') {
                    console.log('getChangeContent', res)
                    this.changeLogList = res.body.listdata
                }
            })
        },
        // getZbxmArchList() {
        //   this.$http({
        //     method: 'post',
        //     url: 'zbgl/zbxmArch/listdata',
        //     params: {
        //       pageNum: this.currentPage,
        //       pageSize: this.pageSize,
        //       listpageId: `5e25ad5dbeb248abb6ddbdb270ae8e15`,
        //       urlsearch: `flSubject:${this.searchValue}`
        //     }
        //   }).then((res) => {
        //     if (res.code === 'success') {
        //       // if (res.body.pageInfo.list.length > 0) {
        //       this.tableData2 = res.body.pageInfo.list
        //       this.total = res.body.pageInfo.total
        //       // }
        //     }
        //   })
        // },
        openxm() {
            this.getZbxmArchList()
            this.showlzDialog3 = true
        },
        xmCancel() {
            this.tableData2 = []
            this.showlzDialog3 = false
        },
        xmSave() {
            this.showlzDialog3 = false
        },
        openZyfj() {
            console.log(this.multipleSelection, 'this.multipleSelection')
            if (this.multipleSelection.length === 0) {
                return this.$message.error('请选择要转移的文件')
            }
            this.zyfj.attachmentIdList = this.multipleSelection.map((item) => item.atttachId)
            console.log(this.vo, this.zyfj, 'openZyfj')
            this.showlzDialog2 = true
        },
        zysmCancel() {
            this.showlzDialog2 = false
            this.zysm = ''
        },
        zysmSave() {
            if (!this.zyfj.projectName) {
                this.$message.error('请选择所属项目')
                return
            }
            this.disBtn2 = true
            const data = {
                projectId: this.zyfj.projectId,
                projectName: this.zyfj.projectName,
                attachmentIdList: this.zyfj.attachmentIdList,
                content: this.zyfj.content
            }
            // return console.log(data, 'data')
            this.$http({
                method: 'post',
                url: 'zbgl/zbxmArch/transferAttachment?sourceProjectId=' + this.vo.id,
                // params: {
                //   pageNum: this.currentPage,
                //   pageSize: this.pageSize,
                //   listpageId: `5e25ad5dbeb248abb6ddbdb270ae8e15`,
                //   urlsearch: `flSubject:${this.searchValue}`
                // }
                data: data
            }).then((res) => {
                if (res.code === 'success') {
                    console.log(res, 'res')
                    this.$message.success(res.message)
                    this.getList()
                    this.getChangeContent()
                    this.disBtn2 = false
                    this.showlzDialog2 = false
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        toupload() {
            if (!this.fileType) {
                this.$message.error('请选择文件类型')
                return
            }
            if (this.fileList.length === 0) {
                this.$message.error('请选择文件')
                return
            }
            this.disBtn = true
            const uploadId = this.vo.id
            this.fileList.forEach((item) => {
                const fd = new FormData()
                fd.append('file', item.raw)
                fd.append('module', 'zbxmArch')
                fd.append('busiDataId', uploadId)
                fd.append('attachsType', this.fileType)
                fd.append('clientType', 'uploader')
                fd.append('attachsName', item.name)
                fd.append('fileType', this.fileType)
                this.$http({
                    method: 'post',
                    url: this.wfEngineUrl + '/upload',
                    data: fd,
                    params: {
                        fileType: this.fileType
                    }
                }).then((res) => {
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                        this.getList()
                        this.disBtn = false
                        this.showlzDialog = false
                    } else {
                        this.$message.error(res.message)
                    }
                })
            })
        },
        getList() {
            this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                params: {
                    id: this.vo.id
                },
                url: this.wfEngineUrl + '/getAttachListById'
            }).then(
                (response) => {
                    if (response.code === 'success') {
                        this.tableData = response.body.listdata
                    } else {
                        this.$message.error(response.message)
                    }
                },
                (err) => {
                    console.log(err)
                }
            )
        },
        todownload(row) {
            console.log(this.multipleSelection, row.atttachId, 'this.multipleSelection')
            if (this.multipleSelection.length === 0 && row.atttachId === undefined) {
                return this.$message.error('请选择要下载的文件')
            }
            if (this.multipleSelection.length > 0) {
                const rowid = this.multipleSelection.map((item) => item.atttachId).join(',')
                window.open('apigw/' + this.wfEngineUrl + '/downloadById?attachIds=' + rowid)
                this.$refs.table.clearSelection()
                this.multipleSelection = []
            } else {
                window.open('apigw/' + this.wfEngineUrl + '/downloadById?attachIds=' + row.atttachId)
                this.$refs.table.clearSelection()
                this.multipleSelection = []
            }
        },
        openwork(row) {
            window.open('apigw/' + this.wfEngineUrl + '/downloadById?attachIds=' + row.atttachId)
        },
        // onSelectListpageRowCompleted(node, attr) {
        //   console.log(node, attr)
        //   if (attr.name == 'fgsName') {
        //     this.vo.fgsName = node[0].name
        //     this.vo.fgsId = node[0].id
        //     this.vo.province = node[0].province
        //     this.vo.city = node[0].city
        //   } else {
        //     this.vo.projectUnit = node[0].name
        //     this.vo.projectFzr = node[0].contacas
        //     this.vo.projectFzrPhone = node[0].contacasTel
        //   }
        // }
        handleSizeChange(val) {
            this.pageSize = val
            this.getZbxmArchList()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getZbxmArchList()
        }
    }
}
</script>

<style scoped lang="scss">
@import '~@/wapp/common/styles/variables.module.scss';

:deep(.el-input__suffix) {
    right: 0px;
    color: #909399;
}

:deep(.el-pagination) {
    text-align: right;
    margin-top: 10px;
}

.change-content {
    margin-top: 10px;

    .text {
        margin-top: 10px;
    }
}
</style>
